module.exports = __webpack_public_path__ + "static/apply-a8c8f1c4fbf55134ac670987c636bb52.png";